import React from 'react';
import TextIconSlider from '../components/TextIconSlider';
import GetAQuoteNewHeroCarousel from '../components/GetAQuoteNewHeroCarousel';
import GetAQuoteEnquiryForm from '../components/GetAQuoteEnquiryForm';

const GetAQuotePage = () => {
  return (
    <>
    <TextIconSlider/>
    <GetAQuoteNewHeroCarousel/>
    <GetAQuoteEnquiryForm title={<h2 className="section-title">Get a <span className="bold">Quote Instantly</span></h2>}/>
    </>
  )
}

export default GetAQuotePage